import { useAPI } from '../../../api';
import { useMemo } from 'react';
import { apiFetcherFactory } from './apiFetcher';

export const useApiFetcher = () => {
  const {
    actions: {
      getMediaFromProvider,
      getMediaDetailsFromProvider,
      registerUsage,
    },
  } = useAPI();

  const apiFetcher = useMemo(
    () =>
      apiFetcherFactory({
        getMediaFromProvider,
        getMediaDetailsFromProvider,
        registerUsage,
      }),
    [getMediaFromProvider, getMediaDetailsFromProvider, registerUsage]
  );

  return apiFetcher;
};
